import { Box, Typography } from '@mui/material';
import { POLICY_CATEGORY_ORDER } from './policy-groups';
import {
  legendHeadingSx,
  LegendNote,
  LegendRoot,
  severityNameSx,
  SeverityRow,
} from './policy-legend.styles';
import { PolicySeverity } from './policy-severity';
import { PolicySeverityGlyph } from './policy-severity-glyph';

const SEVERITY_ROWS: { severity: PolicySeverity; name: string; meaning: string }[] = [
  { severity: 'restriction', name: 'Restriction', meaning: 'never do this' },
  { severity: 'warning', name: 'Warning', meaning: 'conditions or costs apply' },
  { severity: 'info', name: 'Guidance', meaning: 'requirements and good-to-know' },
];

export const SupportPolicyLegend = () => (
  <LegendRoot data-testid="support-policy-legend" id="support-policy-legend">
    <Typography component="span" sx={legendHeadingSx}>
      How to read this list
    </Typography>

    {SEVERITY_ROWS.map(({ severity, name, meaning }) => (
      <SeverityRow key={severity} direction="row">
        <PolicySeverityGlyph severity={severity} titled />
        <Box component="span">
          <Typography component="span" sx={severityNameSx}>
            {name}
          </Typography>{' '}
          &middot; {meaning}
        </Box>
      </SeverityRow>
    ))}

    <LegendNote>
      Escalation policies are the exception: they show their urgency instead, so you read how
      fast to move rather than how firm the rule is. None of them counts as a restriction.
    </LegendNote>

    <LegendNote>
      Icons say how firm a rule is; categories say when in the call it applies. Groups follow
      the call flow: {POLICY_CATEGORY_ORDER.join(' → ')}. A category holding a restriction
      opens on its own.
    </LegendNote>

    <LegendNote>
      The left-nav preview lists only the policies that apply to what is open. This panel can
      also show every policy you can access, plus archived ones, and lets you manage them.
    </LegendNote>
  </LegendRoot>
);
